/**
 * ============================================================
 * MONTE HERMOM | INDEX DASHBOARD
 * ============================================================
 * ARQUIVO: /src/components/dashboard/index_Dashboard.jsx
 * VERSÃO:  3.0.0
 * DATA:    16/09/2026
 *
 * FASE 2: Cada item do menu conecta ao componente real
 * ============================================================
 */

import React, { useState } from 'react';
import { useAuthSaaS } from '../../context/AuthSaaSContext';
import MenuParadigmaLateral from '../perfil/MenuParadigma_lateral';

// ---------- COMPONENTES CONECTADOS ----------
import DashboardSaaS_Amber from './DashBoardSaaS_Amber';
import NovoLaudo           from '../laudo/NovoLaudo';
import PesquisaDashboard   from '../PesquisaDashboard';
import AgendaPrazos        from '../agenda/AgendaPrazos_modulo';
import TarefasParadigma_inicial from '../tarefas/TarefasParadigma_inicial';
import GestaoCredito       from '../admin/faturamento/GestaoCreditoScore_integra';
import UsuarioCadastro     from '../usuario/Usuario_Cadastro_PGLP';
import CadastroGrupo       from '../cadastro/Cadastro_Grupo_Card';
import CartorioManager     from '../CartorioManager';
import ForumManager        from '../ForumManager';
import ImovelParadigma     from '../imovel/ImovelParadigma_inicial';

/* ============================================================
   PLACEHOLDER — para módulos ainda em desenvolvimento
============================================================ */
function Placeholder({ titulo }) {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-8 animate-in fade-in duration-500">
      <div className="text-slate-700 text-6xl mb-6">⚙️</div>
      <h2 className="text-white font-black text-2xl uppercase tracking-widest mb-2">
        {(titulo || '').replace(/_/g, ' ')}
      </h2>
      <p className="text-slate-500 font-black text-[10px] uppercase tracking-[0.3em]">
        Módulo em desenvolvimento
      </p>
    </div>
  );
}

/* ============================================================
   COMPONENTE PRINCIPAL
============================================================ */
export default function IndexDashboard() {
  const { usuario, autenticado, loading } = useAuthSaaS();

  const [abaAtiva, setAbaAtiva]             = useState('DASHBOARD');
  const [menuFinanceiro, setMenuFinanceiro] = useState(false);
  const [menuCadastros, setMenuCadastros]   = useState(false);

  /* ---------- LOADING ---------- */
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center text-white font-black italic">
        Carregando Cockpit…
      </div>
    );
  }

  /* ---------- NÃO AUTENTICADO ---------- */
  if (!autenticado || !usuario) {
    return null;
  }

  /* ---------- CONTEÚDO POR ABA ---------- */
  const renderConteudo = () => {
    switch (abaAtiva) {
      case 'DASHBOARD':
        return <DashboardSaaS_Amber usuario={usuario} />;

      case 'REQUERENTE_INICIAL':
        return <NovoLaudo usuario={usuario} />;

      case 'PESQUISA_GLOBAL':
        return <PesquisaDashboard usuario={usuario} />;

      case 'TAREFAS': 
         return <TarefasParadigma_inicial usuario={usuario} />;

      case 'TAREFAS':
        return <TarefasParadigma usuario={usuario} />;

      case 'CREDITOS':
        return <GestaoCredito usuario={usuario} />;

      case 'USUARIOS':
        return <UsuarioCadastro usuario={usuario} />;

      case 'GRUPOS':
        return <CadastroGrupo usuario={usuario} />;

      case 'CARTORIOS':
        return <CartorioManager usuario={usuario} />;

      case 'FORUM':
        return <ForumManager usuario={usuario} />;

      case 'IMOVEIS_PARADIGMA':
        return <ImovelParadigma usuario={usuario} />;

      /* ---------- PLACEHOLDERS ---------- */
      case 'ORCAMENTOS':
      case 'CONTAS_A_RECEBER':
      case 'CONTAS_A_PAGAR':
      case 'FLUXO_CAIXA':
      case 'COLABORACAO':
        return <Placeholder titulo={abaAtiva} />;

      default:
        return <Placeholder titulo={abaAtiva} />;
    }
  };

  /* ---------- RENDER ---------- */
  return (
    <div className="flex min-h-screen bg-black text-slate-200">
      <MenuParadigmaLateral
        abaAtiva={abaAtiva}
        setAbaAtiva={setAbaAtiva}
        menuFinanceiro={menuFinanceiro}
        setMenuFinanceiro={setMenuFinanceiro}
        menuCadastros={menuCadastros}
        setMenuCadastros={setMenuCadastros}
      />

      <main className="flex-1 overflow-y-auto">
        {renderConteudo()}
      </main>
    </div>
  );
}